<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>Values</legend>

			<div class="form__group">
				<FormControlCurrency name="transaction currency" v-model="formData.currency"
			                     v-validate="'required'"></FormControlCurrency>
			</div>

			<div class="form__group">
				<input id="revenue" name="companyRevenue" class="form__control" v-model="formData.companyRevenue"
				       placeholder="Enter the company's revenue..." v-validate required />
				<label for="revenue" class="form__label">Client company revenue (in millions)</label>
				<div class="form__validation">{{ errors.first('companyRevenue') }}</div>
			</div>

			<!-- TODO: Transaction value label -->
			<div class="form__group">
				<label class="form__label">Projected transaction value (in millions)</label>

				<div class="grid">
					<div class="col-6 col-bleed-y">
						<input id="value-from" name="projectedValueFrom" class="form__control" v-model="formData.projectedValueFrom"
						       placeholder="From..."  v-validate required />
						<div class="form__validation">{{ errors.first('projectedValueFrom') }}</div>
					</div>

					<div class="col-6 col-bleed-y">
						<input id="value-to" name="projectedValueTo" class="form__control" v-model="formData.projectedValueTo"
						       placeholder="To..."  v-validate required />
						<div class="form__validation">{{ errors.first('projectedValueTo') }}</div>
					</div>
				</div>
			</div>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='"submit"'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import OpportunityFormStep from './OpportunityFormStep';
	import ValidationAlert from '../../ValidationAlert';
	import FormControlCurrency from '../../Form/Control/FormControlCurrency';

	export default {
		name: 'OpportunityFormStep4',
		mixins: [OpportunityFormStep],
		components: {
			FormControlCurrency,
			ValidationAlert,
		},
		data() {
			return {
				formData: {
					currency: null,
					companyRevenue: null,
					projectedValueFrom: null,
					projectedValueTo: null,
				}
			}
		},
	}
</script>
